module.exports = ".items-content .btn-remove-item {\n    color: red;\n    cursor: pointer;\n}\n\n.project-toggle {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.project-toggle .form-group {\n    margin-right: 30px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/projects/project-edit/project-edit.component.css
// module id = ./src/app/views/projects/project-edit/project-edit.component.css
// module chunks = main